import React from 'react'
import styled from 'styled-components'
import { useListingBreadcrumbs } from '@sentecacommerce-theme/lib'
import { Breadcrumbs } from '../../../Common'
import { ErrorPage } from '../../../ErrorPage'
import { ErrorPageProps } from '../../../ErrorPage/errorPage.props'

export const NoResults = ({
  notFound,
  title,
}: {
  notFound: ErrorPageProps
  title: string
}) => {
  const { data: breadcrumbData } = useListingBreadcrumbs()
  return (
    <Container>
      <Breadcrumbs isInError isLoading={false} data={breadcrumbData} />
      <ErrorPage {...notFound} subTitle={title} content="" />
    </Container>
  )
}

const Container = styled.div.attrs({
  className: 'd-block',
})`
  height: 100%;
  align-items: center;
`
